import Vue from 'vue'
import BugsnagPluginVue from '@bugsnag/plugin-vue'
import Bugsnag from '@bugsnag/js'
import DataStore from '@/app-core/lib/data/dataStore/DataStore'
import {EventBus} from '@/app-core/lib/events/eventBus'
import {version as appVersion} from '/package.json'

export const setupBugsnag = (options = {}) => {
  // Remove a device ID left over from an earlier setup without privacy mode
  try {
    localStorage.removeItem('bugsnag-anonymous-id')
  } catch (e) { /* storage blocked */
  }

  const AppLog = DataStore.App.Config?.Log
  const AppBugsnag = AppLog?.Bugsnag
  const BugsnagKey = AppBugsnag?.Key || import.meta.env.VITE_LOGGING_BUGSNAG_KEY || ''
  const BugsnagEnvDefaultArr = ['production']
  const BugsnagEnvArr = AppBugsnag?.Env || BugsnagEnvDefaultArr
  const BugsnagEnv = [...new Set([...BugsnagEnvArr, ...BugsnagEnvDefaultArr])]

  const defaultOptions = {
    plugins          : [new BugsnagPluginVue(Vue)],
    apiKey           : BugsnagKey,
    appType          : 'browser',
    appVersion       : `v${appVersion}`,
    autoDetectErrors : true,
    autoTrackSessions: true,

    // --- Privacy ---
    generateAnonymousId: false, // no device ID stored in localStorage
    collectUserIp      : false, // the user's IP is not sent with events

    enabledErrorTypes: {
      unhandledExceptions: true,
      unhandledRejections: true
    },
    enabledReleaseStages: BugsnagEnv,
    releaseStage        : import.meta.env.MODE,
    metaData            : {
      project: {
        name: import.meta.env.VITE_NAME || ''
      }
    },
    onError: function (event) {
      // Adjust event here
    },
    onSession: function (session) {
      // const userId = getMyUserIdentifier() // a custom user resolver
      // session.setUser(userId)
    },
    redactedKeys: [
      'access_token', // exact match: "access_token"
      /^password$/i, // case-insensitive: "password", "PASSWORD", "PaSsWoRd"
      /^cc_/ // prefix match: "cc_number" "cc_cvv" "cc_expiry"
    ],
    trackInlineScripts: true
  }

  if (AppLog?.Active && AppBugsnag?.Active && BugsnagKey) {
    const initOptions = {...defaultOptions, ...options}

    Bugsnag.start(initOptions)
    
    // Vue 2: report errors from components, watchers and lifecycle hooks
    Bugsnag.getPlugin('vue').installVueErrorHandler(Vue)

    EventBus.$on('Auth:Login:Success', onUserLogin)
    // Bugsnag.notify(new Error('Test error'))
  }
}

const onUserLogin = (user) => {
  user?.Id && Bugsnag.setUser(user.Id, user.Email, user.Fullname)
}
